import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson15: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem]">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson14"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Finding Purpose
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson16"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>How To Find Your Purpose?</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>{`Identify the things you care about. `}</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>{`Reflect on what matters most. `}</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>{`Recognize your strengths and talents. `}</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>{`Try volunteering. `}</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>Imagine your best possible self.</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>{`Cultivate positive emotions like gratitude and awe. `}</span>
              </li>
            </ul>
            <p className="m-0">&nbsp;</p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>Look to the people you admire.</span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[35rem] h-[24.44rem] object-cover"
            alt=""
            src="/28@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Body vs Mind:</span>
            </b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To understand yourself well, to understand what you really think
                and mean, you need to simplify things. You have to dissect your
                thoughts and emotions until you get to the core. You do this by
                asking good questions.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                An unclear question will always lead to an unclear answer. Our
                problem is that we don't know how to ask good questions and we
                don't think about the question, only the answer. A good question
                is a way to solve a problem because a problem is no different
                from a question you don't yet have a good answer to. If you know
                how to ask the right question, you are able to understand. If
                you don't know how to formulate a good question, you may come up
                with an answer but that doesn't mean you understand the essence.
                So don't look for answers, but ask the right questions.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <span>
                <b>
                  <span>Examples of Good Questions</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What can I learn from this?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>Why do I do what I do?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>Why do I spend my time doing this?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What can I do to improve myself?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>
                      What can go wrong and what can I do to prevent it?
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>
                      Who can help me with this? What do I need to...?
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What is the next step to...?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What is my (unique) added value?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What do I have to offer?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>Why am I asking this question?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What do I really want to know?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>What do I really mean by this?</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0 text-[1.56rem]">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
          </div>
          <img
            className="relative w-[32rem] h-[34.63rem] object-cover"
            alt=""
            src="/29@2x.png"
          />
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson16"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson15;
